export default "__VITE_ASSET__DGJycopl__"